import { PhoneCall, ClipboardList, Briefcase, Headphones } from "lucide-react";


export default function StepsToCare() {
  return (    
    <section className="py-12 bg-gray-50">
      <div className="text-center mb-10">
        <h2 className="text-3xl font-bold text-gray-800">
          How Our Care Process Works
        </h2>
        {/* 🔹 Subtitle line */}
        <div className="w-24 h-1 bg-gradient-to-r from-teal-400 to-blue-500 mx-auto mt-2 rounded-full"></div>
        <p className="text-gray-600 mt-2 text-sm">
          Simple steps to start care for your loved ones
        </p>
      </div>

      <div className="grid md:grid-cols-4 gap-6 max-w-7xl mx-auto mt-8 px-6">
        {/* CALL US */}
        <div className="p-6 rounded-lg shadow-lg text-center text-white transform transition hover:scale-105 hover:shadow-2xl bg-gradient-to-r from-[#0E7490] to-[#06B6D4]">
          <PhoneCall
            size={50}
            className="mx-auto mb-3 animate-bounce text-white"
          />
          <h3 className="text-xl font-semibold">CALL US</h3>
          <p className="mt-2 text-sm">
            Give us a call to set up a Free Assessment at{" "}
            <strong>630.339.9000</strong>
          </p>
          <button className="mt-4 bg-white text-[#0E7490] font-semibold px-4 py-2 rounded-md shadow hover:bg-gray-100">
            Call Now
          </button>
        </div>

        {/* FREE ASSESSMENT */}
        <div className="p-6 rounded-lg shadow-lg text-center text-white transform transition hover:scale-105 hover:shadow-2xl bg-gradient-to-r from-[#2563EB] to-[#3B82F6]">
          <ClipboardList size={50} className="mx-auto mb-3 text-white" />
          <h3 className="text-xl font-semibold">FREE ASSESSMENT</h3>
          <p className="mt-2 text-sm">
            During your free assessment we will create your personalized plan of
            care.
          </p>
        </div>

        {/* BEGIN CARE */}
        <div className="p-6 rounded-lg shadow-lg text-center text-white transform transition hover:scale-105 hover:shadow-2xl bg-gradient-to-r from-[#1D4ED8] to-[#2563EB]">
          <Briefcase size={50} className="mx-auto mb-3 text-white" />
          <h3 className="text-xl font-semibold">BEGIN CARE</h3>
          <p className="mt-2 text-sm">
            Once the plan of care is set, a dedicated caregiver will be
            assigned.
          </p>
        </div>

        {/* ONGOING SUPPORT */}
        <div className="p-6 rounded-lg shadow-lg text-center text-white transform transition hover:scale-105 hover:shadow-2xl bg-gradient-to-r from-[#0F766E] to-[#14B8A6]">
          <Headphones size={50} className="mx-auto mb-3 text-white" />
          <h3 className="text-xl font-semibold">ONGOING SUPPORT</h3>
          <p className="mt-2 text-sm">
            Your care plan is flexible. We adjust and improve support as needed.
          </p>
        </div>
      </div>
    </section>
  );
}
